
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";
import { toastError, toastSuccess } from "../../AlertMessage/AlertMessage";

// Get Table Data
export const PlantationDetailsPartThreeTableDataAPI = createAsyncThunk("PlantationDetailsPartThreeTableData", async ({ data }) => {
    const {
        FinancialYearID,
        MonthID,
        T_BeneficiaryPlantationDetailsID,
        M_BeneficiaryDetailsID,
        M_TableUserMasterID,
        Flag,
        setPlantationDetails,
        setRubberSaplingData,
        setPlantationDetailsPart4,
        setPlantationTechniquesData,
        setPlantationDetailsPartFive,
        handleSetData,
        PlantationTechniques,
        token
    } = data

    console.log("Flag",Flag)

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    // return fetch(`${BaseUrl}/Transaction/Get_APK_T_BeneficiaryPlantationDetails_3_4_5_Select?T_BeneficiaryPlantationDetailsID=${T_BeneficiaryPlantationDetailsID}&M_BeneficiaryDetailsID=${M_BeneficiaryDetailsID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
    return fetch(`${BaseUrl}/Transaction/Get_Web_T_BeneficiaryPlantationDetails_3_4_5_Select?T_BeneficiaryPlantationDetailsID=${T_BeneficiaryPlantationDetailsID}&FinancialYearID=${FinancialYearID}&MonthID=${MonthID}&M_BeneficiaryDetailsID=${M_BeneficiaryDetailsID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                // toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result.data.table) {
                if (Flag == "PlantationPart3") {
                    setPlantationDetails(result.data.table)
                } if (Flag == "AddPlaningTime") {
                    setRubberSaplingData(result.data.table)
                } if (Flag == "PlantationPart4") {
                    PlantationTechniques(result.data.table)
                    // console.log("PlantationPart",result.data.table);
                    setPlantationDetailsPart4(result.data.table)
                } if (Flag == 'PlantationTechniques') {
                    setPlantationTechniquesData(result.data.table)
                    handleSetData && handleSetData(result.data.table)
                } if (Flag == 'PlantationPart5') {
                    setPlantationDetailsPartFive(result.data.table)

                }

                return result.data.table

            } else {
                // toastError(result.message)
                if (Flag == "PlantationPart3") {
                    setPlantationDetails([])
                } if (Flag == "AddPlaningTime") {
                    setRubberSaplingData([])
                } if (Flag == "PlantationPart4") {
                    setPlantationDetailsPart4([])
                } if (Flag == 'PlantationTechniques') {
                    setPlantationTechniquesData([])
                    handleSetData && handleSetData([])
                } if (Flag == 'PlantationPart5') {
                    setPlantationDetailsPartFive([])

                }
                return result
            }
        })
})

const PlantationDetailsPartThreeTableDataSlice = createSlice({
    name: "PlantationDetailsPartThreeTableData",
    initialState: {
        isFirstPartLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantationDetailsPartThreeTableDataAPI.pending, (state, action) => {
            state.isFirstPartLoading = true;
        });
        builder.addCase(PlantationDetailsPartThreeTableDataAPI.fulfilled, (state, action) => {
            state.isFirstPartLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PlantationDetailsPartThreeTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isFirstPartLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastError('Something went wrong')
        });
    },
})

export const PlantationDetailsPartThreeTableDataReducer = PlantationDetailsPartThreeTableDataSlice.reducer

// --------------------rubber saplings Post API---------------------

export const RubberSaplingsPostAPI = createAsyncThunk("RubberSaplingsPost", async ({ data }) => {
    const {
        M_BeneficiaryDetailsID,
        T_BeneficiaryPlantationDetailsID,
        FinancialYearID,
        MonthsID,
        NoOfPlants,
        M_TableUserMasterID,
        token,
        handleDataIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID);
    formdata.append("FinancialYearID", FinancialYearID);
    formdata.append("MonthsID", MonthsID);
    formdata.append("NoOfPlants", NoOfPlants);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Post_APK_T_BeneficiaryPlantationDetails_AddPlaningTime_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleDataIsPost()
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const RubberSaplingsPostSlice = createSlice({
    name: "RubberSaplingsPost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(RubberSaplingsPostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(RubberSaplingsPostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(RubberSaplingsPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const RubberSaplingsPostReducer = RubberSaplingsPostSlice.reducer

// Get Status of intercrops table 
export const StatusOfIntercropsTableDataAPI = createAsyncThunk("StatusOfIntercropsTableData", async ({ data }) => {
    const {
        T_BeneficiaryPlantationDetailsID,
        M_BeneficiaryDetailsID,
        ReplaceCrop_M_IndicatorMasterID,
        M_TableUserMasterID,
        Flag,
        setStatusInterCropsData,
        handleSetData,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Transaction/Get_APK_T_BeneficiaryPlantationDetails_StatusInterCrops_3_Select?T_BeneficiaryPlantationDetailsID=${T_BeneficiaryPlantationDetailsID}&M_BeneficiaryDetailsID=${M_BeneficiaryDetailsID}&ReplaceCrop_M_IndicatorMasterID=${ReplaceCrop_M_IndicatorMasterID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result.data.table) {
                setStatusInterCropsData(result.data.table)
                handleSetData && handleSetData(result.data.table)
                return result.data.table

            } else {
                // toastError(result.message)
                return result
            }
        })
})

const StatusOfIntercropsTableDataSlice = createSlice({
    name: "StatusOfIntercropsTableData",
    initialState: {
        isFirstPartLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(StatusOfIntercropsTableDataAPI.pending, (state, action) => {
            state.isFirstPartLoading = true;
        });
        builder.addCase(StatusOfIntercropsTableDataAPI.fulfilled, (state, action) => {
            state.isFirstPartLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(StatusOfIntercropsTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isFirstPartLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const StatusOfIntercropsTableDataReducer = StatusOfIntercropsTableDataSlice.reducer

// --------------------Status of intercrops Post API---------------------

export const StatusOfIntercropsPostAPI = createAsyncThunk("StatusOfIntercropsPost", async ({ data }) => {
    const {
        M_BeneficiaryDetailsID,
        T_BeneficiaryPlantationDetailsID,
        ReplaceCrop_M_IndicatorMasterID,
        RawData,
        M_TableUserMasterID,
        token,
        handleInterCropsDataIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID);
    formdata.append("ReplaceCrop_M_IndicatorMasterID", ReplaceCrop_M_IndicatorMasterID);
    formdata.append("RawData", RawData);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Post_APK_T_BeneficiaryPlantationDetails_StatusInterCrops_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleInterCropsDataIsPost()
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const StatusOfIntercropsPostSlice = createSlice({
    name: "StatusOfIntercropsPost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(StatusOfIntercropsPostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(StatusOfIntercropsPostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(StatusOfIntercropsPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const StatusOfIntercropsPostReducer = StatusOfIntercropsPostSlice.reducer


// InsertUpdate Table Data
export const PlantationDetailsPartThreePatchAPI = createAsyncThunk("PlantationDetailsPartThreePatch", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        T_BeneficiaryPlantationDetailsID,
        M_BeneficiaryDetailsID,
        PlanDistance_M_IndicatorID,
        RubberPlants_M_IndicatorID,
        ChallengesInPlantation,
        StatusOfIntercrops_M_IndicatorID,
        StatusOfLand_M_IndicatorID,
        LandOwnership_M_IndicatorID,
        LandPreparation_M_IndicatorID,
        M_TableUserMasterID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("FinancialYearID",FinancialYearID);
    formdata.append("MonthsID", MonthsID);
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID ? T_BeneficiaryPlantationDetailsID : 0);
    formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
    formdata.append("PlanDistance_M_IndicatorID", PlanDistance_M_IndicatorID);
    formdata.append("RubberPlants_M_IndicatorID", RubberPlants_M_IndicatorID);
    formdata.append("ChallengesInPlantation", ChallengesInPlantation);
    formdata.append("StatusOfIntercrops_M_IndicatorID", StatusOfIntercrops_M_IndicatorID);
    formdata.append("StatusOfLand_M_IndicatorID", StatusOfLand_M_IndicatorID);
    formdata.append("LandOwnership_M_IndicatorID", LandOwnership_M_IndicatorID);
    formdata.append("LandPreparation_M_IndicatorID", LandPreparation_M_IndicatorID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "PATCH",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/APK_T_BeneficiaryPlantationDetails_3_Update`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleIsPost()
                toastSuccess(result.message)
            } else {
                toastError("Something went wrong")
            }
            return result
        })
})

const PlantationDetailsPartThreePatchSlice = createSlice({
    name: "BeneficiaryPost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantationDetailsPartThreePatchAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(PlantationDetailsPartThreePatchAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(PlantationDetailsPartThreePatchAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;
            // toastError('Something went wrong')

        });
    },
})

export const PlantationDetailsPartThreePatchReducer = PlantationDetailsPartThreePatchSlice.reducer

// --------------------Post_APK_M_CommanOther_Insert Post API---------------------

export const CommanOtherPostAPI = createAsyncThunk("CommanOtherPost", async ({ data }) => {
    const {
        Other,
        Flag,
        M_TableUserMasterID,
        token,
        handleIsOtherPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("Other", Other);
    formdata.append("Flag", Flag);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Post_APK_M_CommanOther_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleIsOtherPost()
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const CommanOtherPostSlice = createSlice({
    name: "CommanOtherPost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(CommanOtherPostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(CommanOtherPostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(CommanOtherPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const CommanOtherPostReducer = CommanOtherPostSlice.reducer

// ------------------------------Status of intercrops  -------------------------------

export const StatusOfIntercropsDeleteAPI = createAsyncThunk("StatusOfIntercropsDelete", async ({ data }) => {
    const {
        T_BeneficiaryPlantationDetails_StatusInterCropsID,
        M_TableUserMasterID,
        token,
        handleInterCropsDataIsPost,
        handleShowDelete
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryPlantationDetails_StatusInterCropsID", T_BeneficiaryPlantationDetails_StatusInterCropsID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "DELETE",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Web_T_BeneficiaryPlantationDetails_StatusInterCrops_Delete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleInterCropsDataIsPost()
                handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const StatusOfIntercropsDeleteSlice = createSlice({
    name: "StatusOfIntercropsDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(StatusOfIntercropsDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(StatusOfIntercropsDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(StatusOfIntercropsDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const StatusOfIntercropsDeleteReducer = StatusOfIntercropsDeleteSlice.reducer

// ------------------------------Rubber Saplings Delete API  -------------------------------

export const RubberSaplingsDeleteAPI = createAsyncThunk("RubberSaplingsDelete", async ({ data }) => {
    const {
        T_BeneficiaryPlantationDetails_AddPlaningTimeID,
        M_TableUserMasterID,
        token,
        handleDeleteDataIsPost,
        handleShowDelete
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryPlantationDetails_AddPlaningTimeID", T_BeneficiaryPlantationDetails_AddPlaningTimeID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "DELETE",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/APK_T_BeneficiaryPlantationDetails_AddPlaningTime_Delete?`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleDeleteDataIsPost()
                handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const RubberSaplingsDeleteSlice = createSlice({
    name: "RubberSaplingsDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(RubberSaplingsDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(RubberSaplingsDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(RubberSaplingsDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const RubberSaplingsDeleteReducer = RubberSaplingsDeleteSlice.reducer



